import { takeLatest, call, put } from 'redux-saga/effects'
import {
    contactUsMessageListAPI, contactUsNewRecordAPI
} from '../api-requests/contactUs';
import {
    contactUsMessageListRequestError, contactUsMessageListRequestSuccess,
    contactUsSendMessageRequestError, contactUsSendMessageRequestSuccess
} from './contactUs.action';
import { ContactUsActionTypes } from './contactUs.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleContactUsNewMessage({ payload }) {
    try {
        const response = yield call(contactUsNewRecordAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(contactUsSendMessageRequestSuccess(decryptedData))
            } else {
                yield put(contactUsSendMessageRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(contactUsSendMessageRequestError(error.response.data))
    }
}

export function* contactUsNewMessageReq() {
    yield takeLatest(ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST, handleContactUsNewMessage)
}

function* handleContactUsMessageList({ payload }) {
    try {
        const response = yield call(contactUsMessageListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(contactUsMessageListRequestSuccess(decryptedData))
            } else {
                yield put(contactUsMessageListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(contactUsMessageListRequestError(error.response.data))
    }
}

export function* contactUsMessageListReq() {
    yield takeLatest(ContactUsActionTypes.CONTACT_US_MESSAGE_LIST_REQUEST, handleContactUsMessageList)
}